import React, { Component } from 'react';
// import { Resizable } from 're-resizable';
import { connect } from 'react-redux';
import { Portal } from 'react-portal';
import ContainerDimensions from 'react-container-dimensions';
import cx from 'classnames';
import qs from 'query-string';

import Sidebar from '../containers/Sidebar';
import ArticleTable from '../containers/ArticleTable';
import ArticleDetailsModal from './ArticleDetailsModal';
import { selectors as appSelectors } from '../reducers/appReducer';
import { toggleSidebar } from '../actions/appActions';
import { fetchItems, resetItems } from '../actions/itemsActions';
import { loadFiltersFromLocalStorage, refreshFiltersValues, resetAllFilters } from '../actions/filtersActions';
import { getFromInternalPage, getLoadedFromOtherPages, getPublicRedirect } from '../reducers/pageStateReducer';
import {
    setIsLoadingFromLocalStorage,
    setLoadedFromOthersPages,
    setLoadingFromLocalStorage,
    clearPublicRedirect
} from '../actions/pageStateActions';
import { resetSagas } from '../actions/sagaStatusActions'; // Import the action to load filters


// function getMinSidebarWidth(windowWidth) {
//     const w = Math.floor(windowWidth / 5);

//     if (w > 250) {
//         return w;
//     }

//     return 250;
// }

// function getMaxSidebarWidth(windowWith) {
//     const w = Math.floor(windowWith / 3);

//     if (w > 0) {
//         return w;
//     }

//     return 400;
// }

export class DataPoolComponent extends Component {
    state = {
        showArticleModal: false,
    };

    componentDidMount() {
        //console.log('mounting DatapoolComponent')

        this.props.dispatch(resetItems())
        const search = qs.parse(window.location.search)

        // *** CARICAMENTO DAL LOCAL STORAGE *** //
        // Load filters from localStorage when the component mounts
        if(this.props.canLoadFiltersFromLocalStorage){
            this.props.dispatch(loadFiltersFromLocalStorage())
        }else{
            this.props.dispatch(setIsLoadingFromLocalStorage(false))
            this.props.dispatch(fetchItems())
        }

        // *** - *** //

        if (search.showArticle) {
            this.setState({
                showArticleModal: search.showArticle,
            });

            // TODO: replace url per eliminare querystring?
        }

        // Controllo se arrivo da un redirect dalla pagina pubblica
        if (this.props.publicRedirect && this.props.publicRedirect.articleId) {
            this.setState({
                showArticleModal: this.props.publicRedirect.articleId,
            });
            // Pulisco lo stato del redirect
            this.props.dispatch(clearPublicRedirect());
        }
    }

    componentDidUpdate(prevProps) {

        /*!this.props.fromInternalPage && this.props.dispatch(loadFiltersFromLocalStorage())
        this.props.fromInternalPage && this.props.dispatch(fetchItems())*/
    }

    componentWillUnmount(){
        this.props.dispatch(setIsLoadingFromLocalStorage(false))
        if(this.props.canLoadFiltersFromLocalStorage){
            this.props.dispatch(resetAllFilters())
            this.props.dispatch(resetSagas())
        }

    }

    render() {
        const { /*width,*/ isSidebarOpen, toggleSidebar } = this.props;

        return (
            <div className="flex">
                {/* <Resizable
                    defaultSize={{
                        width: getMinSidebarWidth(width),
                        height: 'auto',
                    }}
                    minWidth={getMinSidebarWidth(width)}
                    maxWidth={getMaxSidebarWidth(width)}
                    enable={{
                        top: false,
                        right: true,
                        bottom: false,
                        left: false,
                        topRight: false,
                        bottomRight: false,
                        bottomLeft: false,
                        topLeft: false,
                    }}
                > */}
                <ContainerDimensions>
                    {({ height, width }) => {
                        return (
                            <div
                                className={cx(
                                    'sidebar-area px-2 fixed lg:relative w-5/6 lg:w-3/12 z-10 lg:z-auto pt-1 bg-gray-200 lg:bg-white',
                                    {
                                        hidden: !isSidebarOpen && width < 1024,
                                    }
                                )}
                            >
                                <Sidebar height={height}/>
                            </div>
                        );
                    }}
                </ContainerDimensions>
                <div
                    onClick={toggleSidebar}
                    className={cx(
                        'lg:hidden z-[1] bg-slate-600 opacity-50 w-full h-screen absolute',
                        {
                            hidden: !isSidebarOpen,
                        }
                    )}
                />
                {/* </Resizable> */}
                <div
                    className="px-1 overflow-y-auto flex flex-col flex-1 w-full mt-1"
                    style={{ overflow: 'hidden' }}
                >
                    <ArticleTable />
                </div>
                {this.state.showArticleModal && (
                    <Portal>
                        <ArticleDetailsModal
                            article={{ id: this.state.showArticleModal }}
                            onClose={() => this.setState({ showArticleModal: false })}
                            containerId={`article-detail-modal-${this.state.showArticleModal}`}
                        />
                    </Portal>
                )}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isSidebarOpen: appSelectors.getIsSidebarOpen(state),
        fromInternalPage: getFromInternalPage(state),
        setIsLoadingFromLocalStorage: setIsLoadingFromLocalStorage(state),
        loadedFromOthersPage: getLoadedFromOtherPages(state),
        canLoadFiltersFromLocalStorage: appSelectors.getLoadFiltersFromLocalStorage(state),
        publicRedirect: getPublicRedirect(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        toggleSidebar() {
            dispatch(toggleSidebar());
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DataPoolComponent);
